import { render, staticRenderFns } from "./searchCert.vue?vue&type=template&id=0a5f2cfe&scoped=true&"
import script from "./searchCert.vue?vue&type=script&lang=js&"
export * from "./searchCert.vue?vue&type=script&lang=js&"
import style0 from "./searchCert.vue?vue&type=style&index=0&id=0a5f2cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f2cfe",
  null
  
)

export default component.exports